import { render, staticRenderFns } from "./pay-channel-group-cost-management.vue?vue&type=template&id=1347ef12&scoped=true&"
import script from "./pay-channel-group-cost-management.vue?vue&type=script&lang=js&"
export * from "./pay-channel-group-cost-management.vue?vue&type=script&lang=js&"
import style0 from "./pay-channel-group-cost-management.vue?vue&type=style&index=0&id=1347ef12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1347ef12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1347ef12')) {
      api.createRecord('1347ef12', component.options)
    } else {
      api.reload('1347ef12', component.options)
    }
    module.hot.accept("./pay-channel-group-cost-management.vue?vue&type=template&id=1347ef12&scoped=true&", function () {
      api.rerender('1347ef12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-channel-management/pay-channel-group-cost-management.vue"
export default component.exports